import {DropzoneComponent} from 'react-dropzone-component';
import 'react-dropzone-component/styles/filepicker.css';
import 'dropzone/dist/min/dropzone.min.css';
import React, {Component} from 'react';
import {Button, Header, Popup, Icon,Segment,ButtonGroup, Image,Label,Input,Message} from 'semantic-ui-react';
import {uploadAdditionalImage, getAdditionalInspectionImages,getAdditionalVisitImages,deleteAdditionalImage,deleteAllAdditionalImages} from "../../data/inspection_api";
import * as unavailable from "../../assets/photo_unavailable.jpg";
import Loader from "../universal/loader";
import ReportContainer from "../../containers/report_container"
import * as camera_shutter from "../../assets/camera_shutter.mp3";

const uuidv1 = require('uuid/v1');

class AdditionalPhotos extends Component {

    constructor(props) {
        super(props);
        this.videoRef = React.createRef();
        this.canvasRef = React.createRef();
        this.state = {
            attachments: [],
            maxNumberOfFilesExceeded: false,
            saved: false,
            uploading:false,
            preLoaded: false,
            loading: true,
            imageData: null,
            uploadCount: 0,
            queue: [],
            concurrentRequests:0,
            overlayHeight:30,
            selectedImg:undefined,
            selectedIndex:undefined,
            showCamera:false,
            uploadingPhoto:false,
            uploadErrors:[],
            isFlashing:false,
            torchEnabled:false,
            torchSupported:false,
            availableCameras: undefined,
            currentCameraIndex: 0,
            isMobile: window.innerWidth < 768,
            lagMode:false
        };
    }

    componentWillMount() {
        this.getAdditionalImages(this.props.forceOverlay).then(() => {
            this.setState({ loading: false });
       })
    }

   handleCapture = async () => {
  this.jumpToCamera();
  this.setState({ isFlashing: true });
  setTimeout(() => {
    this.setState({ isFlashing: false });
  }, 600);



  let blob;
  let dataUrl;
  const video = this.videoRef.current;

  try {
    const track = this.stream && this.stream.getVideoTracks
      ? this.stream.getVideoTracks()[0]
      : null;

    if (!track) throw new Error("No video track available");

    const imageCapture = new window.ImageCapture(track);

      // Try full-resolution photo
    let caps = null;
    try { caps = await imageCapture.getPhotoCapabilities(); } catch(e) { }

    if (caps && caps.imageWidth && caps.imageWidth.max && caps.imageHeight&& caps.imageHeight.max) {
      blob = await imageCapture.takePhoto({
        imageWidth: caps.imageWidth.max,
        imageHeight: caps.imageHeight.max
      });
    } else {
      blob = await imageCapture.takePhoto();
    }
     this.playCameraClick();
    // Convert blob to dataUrl
    dataUrl = await new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });

  } catch (error) {
    //FALLBACK
    const canvas = document.createElement("canvas");
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    const ctx = canvas.getContext("2d");
    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

    dataUrl = canvas.toDataURL("image/png");
    this.playCameraClick();
    const byteString = atob(dataUrl.split(",")[1]);
    const mimeString = dataUrl.split(",")[0].split(":")[1].split(";")[0];
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const uint8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i++) {
      uint8Array[i] = byteString.charCodeAt(i);
    }
    blob = new Blob([uint8Array], { type: mimeString });
    //END FALLBACK
  }
  const uuid = uuidv1();
  const tempFile = { id: uuid, file: dataUrl, loading: true };

  this.props.updateOverlayImageList([
    ...this.props.overlayImageList,
    tempFile,
  ]);
  this.props.setSelectedOverlayImage(tempFile);
  this.jumpToCamera();
  const formData = new FormData();
  formData.append("id", uuid);
  formData.append(
    "file",
    blob,
    `${this.props.overlayImageList.length + 1}.png`
  );
  if (this.props.inspection_id) {
    formData.append("inspection_id", this.props.inspection_id);
  }

  const response = await uploadAdditionalImage(formData);
  const newOverlayImageList = [...this.props.overlayImageList];
  const tempIndex = newOverlayImageList.indexOf(tempFile);

  if (response.success) {
    if (tempIndex !== -1) {
      newOverlayImageList[tempIndex] = {
        id: response.id,
        file: response.file,
      };
    }
    this.props.updateOverlayImageList(newOverlayImageList);
    if (this.props.overlayImage.id === response.id) {
      this.props.setSelectedOverlayImage(
        { id: response.id, file: response.file },
        false
      );
    }
  } else {
    if (tempIndex !== -1) {
      newOverlayImageList.splice(tempIndex, 1);
    }
    this.props.updateOverlayImageList(newOverlayImageList);
    if (this.props.overlayImage === tempFile) {
      this.props.setSelectedOverlayImage(undefined);
    }
    this.setState({
      uploadErrors: [...this.state.uploadErrors, formData],
    });
  }

  this.jumpToCamera();
};

    playCameraClick = () => {
  const audio = new Audio(camera_shutter);
  audio.play().catch((error) => {
    console.error("Error playing camera click sound:", error);
  }
  );
  }         
      
      
        
      retryFailedUploads = async () => {
        this.setState({ uploadingPhoto: true });
      
        const failedUploads = this.state.uploadErrors;
        const newFailedUploads = [];
      
        for (const formData of failedUploads) {
          try {
            const response = await uploadAdditionalImage(formData);
            if (response.success) {
                let newFile = { id: response.id, file: response.file }
                this.props.updateOverlayImageList([...this.props.overlayImageList, newFile ])
                this.props.setSelectedOverlayImage(newFile)
            } else {
              newFailedUploads.push(formData);
            }
          } catch (error) {
            newFailedUploads.push(formData);
          }
        }
      
        this.setState({
          uploadingPhoto: false,
          uploadErrors: newFailedUploads,
        });
      };
      
    componentWillUnmount() {
        this.closeCamera()
      }

      closeCamera = () => {
        this.setState({showCamera:false})
        if (this.stream) {
            this.stream.getTracks().forEach(track => track.stop());
            this.stream = null; // 
          }
      }

      toggleTorch = async () => {
        if (!this.stream) return;
      
        const track = this.stream.getVideoTracks()[0];
        const capabilities = track.getCapabilities ? track.getCapabilities() : null;
      
        if (capabilities && capabilities.torch) {
          const currentTorchState = this.state.torchEnabled;
      
          try {
            await track.applyConstraints({
              advanced: [{ torch: !currentTorchState }],
            });
      
            this.setState({ torchEnabled: !currentTorchState });
          } catch (err) {
            console.warn("Failed to toggle torch:", err);
          }
        } else {
          console.warn("Torch not supported on this device");
        }
      };
      
      initCycleCamera = async () => {
        if (this.stream) {
          this.stream.getTracks().forEach(track => track.stop());
          this.stream = null;
        }
      
        try {
          // Step 1: Ask for permission to unlock device labels
          await navigator.mediaDevices.getUserMedia({ video: true });
      
          // Step 2: Get available cameras
          const devices = await navigator.mediaDevices.enumerateDevices();
          const videoInputs = devices.filter(device => device.kind === "videoinput");
      
          if (videoInputs.length === 0) {window.alert("No cameras found")}
      
          // Step 3: Select preferred (rear-facing if available)
          let preferredIndex = 0;
          for (let i = 0; i < videoInputs.length; i++) {
            const label = videoInputs[i].label.toLowerCase();
            if (label.includes("back") || label.includes("rear")) {
              preferredIndex = i;
              break;
            }
          }
    
          // Step 4: Start stream with preferred camera
            await this.startCameraStream({
              deviceId: { exact: videoInputs[preferredIndex].deviceId },
              width: { ideal: 4096, max: 4096 },
              height: { ideal: 2160, max: 2160 },
              aspectRatio: { ideal: 4 / 3 }
            });
      
          // Step 5: Update state
          this.setState({
            availableCameras: videoInputs,
            selectedCameraId: videoInputs[preferredIndex].deviceId,
          });
      
        } catch (err) {
          console.error("Camera error:", err);
        }
      
        this.jumpToCamera();
      };
      
startCameraStream = async (camConstraints) => {
  // Stop old stream
  if (this.stream) {
    this.stream.getTracks().forEach(function(track) { track.stop(); });
    this.stream = null;
  }

  try {
    // Merge high-res defaults into camConstraints
    var videoConstraints = Object.assign({}, camConstraints, {
      width: { min: 640, ideal: 4096, max: 4096 },
      height: { min: 480, ideal: 2160, max: 2160 },
      aspectRatio: { ideal: 4 / 3 }
    });

    var stream = await navigator.mediaDevices.getUserMedia({
      audio: false,
      video: videoConstraints
    });

    this.stream = stream;

    // Attach stream to video element
    if (this.videoRef.current) {
      this.videoRef.current.srcObject = stream;
      this.videoRef.current.onloadedmetadata = function() {
        this.videoRef.current.play();
      }.bind(this);
    }

    // Get video track + capabilities
    var track = stream.getVideoTracks()[0];
    var capabilities = track.getCapabilities ? track.getCapabilities() : null;

    //
    // ⬇⬇ APPLYING SAFE CAPABILITIES ⬇⬇
    //

    // 1. Max resolution
    if (capabilities && capabilities.width && capabilities.height) {
      try {
        await track.applyConstraints({
          width: capabilities.width.max,
          height: capabilities.height.max
        });
      } catch (e) {}
    }

    // 2. Continuous exposure (auto exposure)
    if (capabilities && capabilities.exposureMode &&
        capabilities.exposureMode.indexOf("continuous") !== -1) {
      try {
        await track.applyConstraints({
          advanced: [{ exposureMode: "continuous" }]
        });
      } catch (e) {}
    }

    // 3. Continuous white balance
    if (capabilities && capabilities.whiteBalanceMode &&
        capabilities.whiteBalanceMode.indexOf("continuous") !== -1) {
      try {
        await track.applyConstraints({
          advanced: [{ whiteBalanceMode: "continuous" }]
        });
      } catch (e) {}
    }

    // 4. Continuous autofocus
    if (capabilities && capabilities.focusMode &&
        capabilities.focusMode.indexOf("continuous") !== -1) {
      try {
        await track.applyConstraints({
          advanced: [{ focusMode: "continuous" }]
        });
      } catch (e) {}
    }

    // 5. Set zoom to min (safe default)
    if (capabilities && capabilities.zoom &&
        typeof capabilities.zoom.min === "number") {
      try {
        await track.applyConstraints({
          advanced: [{ zoom: capabilities.zoom.min }]
        });
      } catch (e) {}
    }

    // 6. Torch handling (already existed)
    if (capabilities && capabilities.torch) {
      try {
        await track.applyConstraints({ advanced: [{ torch: false }] });
        this.setState({ torchSupported: true, torchEnabled: false });
      } catch (e) {
        console.warn("Torch supported but failed to enable:", e);
        this.setState({ torchSupported: true, torchEnabled: false });
      }
    } else {
      this.setState({ torchSupported: false, torchEnabled: false });
    }

    //
    // ⬆⬆ END CAPABILITY HANDLING ⬆⬆
    //

  } catch (err) {
    console.log("startCameraStream error: " + err);
  }
};


      toggleCamera = async () => {
        if(this.state.availableCameras == undefined) { await this.initCycleCamera() } else {
        if (!this.state.availableCameras || this.state.availableCameras.length < 2) return;
      
        let currentCameraIndex = this.state.currentCameraIndex < this.state.availableCameras.length - 1? this.state.currentCameraIndex + 1 : 0
        const nextDevice = this.state.availableCameras[currentCameraIndex];
      
        this.setState({ selectedCameraId: nextDevice.deviceId,currentCameraIndex:currentCameraIndex });
        await this.startCameraStream({deviceId: { exact: nextDevice.deviceId  }});
        }
      };
      
    reloadAdditionalImages = async ()  =>{
        this.setState({ loading: true });
        await   this.getAdditionalImages()
        this.setState({ loading: false });
    }

    jumpToCamera= () => {   
        const container = document.querySelector('.image-overlay-inner');
        container.scrollLeft = 0; 
    }
    jumpToItem= (itemNumber, ignoreCheck = false) => {
        if(!ignoreCheck) {
            if (this.state.selectedIndex) { itemNumber += this.state.selectedIndex} else {itemNumber += this.props.overlayImageList.length}
        }
        if(itemNumber < 1) { itemNumber = 1}
        if( itemNumber > this.props.overlayImageList.length) { itemNumber = (this.props.overlayImageList.length)}
        this.setState({selectedIndex:itemNumber})
        this.props.setSelectedOverlayImage(this.props.overlayImageList[itemNumber-1])
    }
    uploadImages = async (formData) => {
        const response = await uploadAdditionalImage(formData);
        this.setState({ uploadCount: this.state.uploadCount + 1 })
        this.setState({ uploadCountText: "Uploading image " + (this.state.uploadCount + 1) + " of " + this.state.attachments.length })
            this.successCallback(response);
    }
    
    deleteAll = async () => {
        this.setState({loading:true})
        let response = undefined
        if(this.props.inspection_id) {
            let paramDel = {inspection_id:this.props.inspection_id}
             response = await deleteAllAdditionalImages(paramDel)
        }
        if(this.props.pv_id) {
            let paramDel = {pv_id:this.props.pv_id}
            response = await deleteAllAdditionalImages(paramDel)
        }
        
        this.getAdditionalImages().then(() => {
            this.setState({ loading: false, attachments:[] });
        })
    }
    getAdditionalImages = async (openOverlay = false) => {
        if (this.props.inspection_id){
            const response = await getAdditionalInspectionImages(this.props.inspection_id)
            let sortedImages = response.sort((a,b)=>{return (a.file_name || "1").localeCompare (b.file_name || "1")})
            this.setState({ imageData: sortedImages })
            if(openOverlay) {
              this.props.updateOverlayImageList(sortedImages)
            }
        }
        
        if (this.props.pv_id) {
            const response = await getAdditionalVisitImages(this.props.pv_id)
            this.setState({ imageData: response }) 
        }
    }

sortAdditionalImages = async (sortType) => {
    // Create a new array instance to ensure React detects the change and re-renders.
    let currentImages = [...this.props.overlayImageList]; 

    if (sortType === "filenameasc") {
        currentImages.sort((a, b) => {
            // Use 'localeCompare' for string sorting.
            // Fallback to "1" ensures consistent behavior for missing filenames,
            // placing them in a predictable order. Adjust "1" if a different
            // fallback character (e.g., empty string) is desired for sorting.
            return (a.file_name || "1").localeCompare(b.file_name || "1");
        });
    } else if (sortType === "filenamedesc") {
        currentImages.sort((a, b) => {
            return (b.file_name || "1").localeCompare(a.file_name || "1");
        });
    } else if (sortType === "dateasc") {
        currentImages.sort((a, b) => {
            // Convert dates to numerical timestamps for accurate comparison.
            // Fallback to 0 (epoch) for missing or invalid dates.
            const dateA = new Date(a.created_at || 0).getTime();
            const dateB = new Date(b.created_at || 0).getTime();
            return dateA - dateB; // Ascending numeric sort
        });
    } else if (sortType === "datedesc") {
        currentImages.sort((a, b) => {
            const dateA = new Date(a.created_at || 0).getTime();
            const dateB = new Date(b.created_at || 0).getTime();
            return dateB - dateA; // Descending numeric sort
        });
    }

    // Update the parent component's state with the newly sorted array.
    this.props.updateOverlayImageList(currentImages);
};
    


    handleSubmit = async () => {
        this.setState({ uploading: true });
        var queueAttachments = []
        var uploadingFiles = []
        var concurrentRequests = 0
        var concurrentRequestLimit = 3
        var uploadCount = 0
        if (this.state.attachments.length > 0) {
            for (let i = 0; i < this.state.attachments.length; i++) {
                if (this.state.attachments[i].status === "queued") {
                    const formData = new FormData();
                    formData.append("id", this.state.attachments[i].upload.uuid);
                    formData.append("file", this.state.attachments[i]);
                    if(this.props.inspection_id) {
                        formData.append("inspection_id",this.props.inspection_id);
                    }
                        if(this.props.pv_id) {
                            formData.append("pv_id", this.props.pv_id);
                        }

                    if (concurrentRequests < concurrentRequestLimit) {
                        concurrentRequests += 1
                        uploadingFiles.push(formData)
                    }
                    else {queueAttachments.push(formData)}
                }
                else {
                uploadCount += 1  
                }
            }
            if (uploadingFiles.length < 1) {
                this.setState({uploading:false})
            }
            else {
                this.setState({ queue: queueAttachments, concurrentRequests: concurrentRequests, uploadCount: uploadCount, uploadCountText: "Uploading image " + (uploadCount + 1) + " of " + this.state.attachments.length, totalCount: this.state.attachments.length })      
                for (let i = 0; i < uploadingFiles.length; i++) {
                    this.uploadImages(uploadingFiles[i])
                }
            }
        }
       
    };
    
    successCallback = async (response) => {
        var newQueue = this.state.queue
        var formData = newQueue.pop()
        if (formData) {
            this.setState({ queue: newQueue })
            this.uploadImages(formData, this.props.inspection_id)
        } else {
            if (this.state.concurrentRequests < 2) {
                this.setState({ saved: true, uploading: false, loading: true, attachments: [], uploadCount: 0,concurrentRequests:0 });
                setTimeout(() => {
                    this.setState({ saved: false })
                }, 20000);
                this.getAdditionalImages().then(() => {
                    this.setState({ loading: false });
                })
            }
            else {this.setState({concurrentRequests: this.state.concurrentRequests - 1})}
        }
    }
    preloadImages = (dropzone,imageData) => {
        if (imageData) {
            for (let i = 0; i < imageData.length; i++){
            const name = imageData[i].id
            const file = {url: imageData[i].file?imageData[i].file:unavailable, name: name, size: 1000000, id: name};
            const imageUrl = imageData[i].file;

            file['serverId'] = name;
            file['accepted'] = true;
            file['status'] = 'success';
            file['upload'] = {
                progress: 100,
                total: 100000,
                bytesSent: 100000
            };
            dropzone.files.push(file);
            this.state.attachments.push(file)
            this.setState({preLoaded:true});
            dropzone.emit("addedfile", file);
            dropzone.emit("thumbnail", file, imageUrl);
                dropzone.emit("complete", file);
            }
        }
    };

    removingFile = (file) => {
        let attachments = this.state.attachments;
        if (attachments.indexOf(file) !== -1) {
            attachments.splice(attachments.indexOf(file), 1);
        }
        if(this.props.inspection_id) {
            let params = {image_id:file.id} 
            deleteAdditionalImage(params) 
        }
        if(this.props.pv_id) {
            let params = {pv_image_id:file.id} 
            deleteAdditionalImage(params)   
        }

        return attachments;
    };

    render() {
        let dropZone = null;
        const componentConfig = {postUrl: 'no-url'};
        let djsConfig = {autoProcessQueue: false, addRemoveLinks: true, maxFiles: 2000,acceptedFiles:"image/*"};
        const eventHandlers = {
            init: (dropzone) => {
                dropZone = dropzone;
                dropZone.autoDiscover = false;
                this.preloadImages(dropzone, this.state.imageData);
            },
            addedfile: (file) => {
                this.state.attachments.push(file);
                this.setState({fileAdded:true,preLoaded:false});
            },
            removedfile: (file) => {
                this.setState({ attachments: this.removingFile(file) })          },
            maxfilesexceeded: (file) => {
                dropZone.removeFile(file);
                this.setState({maxNumberOfFilesExceeded: true});
                setTimeout(() => {
                    this.setState({maxNumberOfFilesExceeded: false})
                }, 10000)
            }
        };

        //getting pic index for automatic selecting when opening overlay
        let selectedPicIndex = 0
        if(this.props.overlayImageList) {
          let reversedOverlayImageList = [...this.props.overlayImageList].reverse()
          if(this.props.overlayImage)
          { selectedPicIndex = reversedOverlayImageList.indexOf(this.props.overlayImage) } else {
            this.props.setSelectedOverlayImage(reversedOverlayImageList[0])
          }
        }

        return (<div>
            {this.state.loading ? <Loader contain={true}/> : !this.props.overlayImageList &&<React.Fragment>
                <Header textAlign="left"> Additional Photos {this.state.saved && <span className="info-success">Saved!</span>} {this.state.uploading && <span className="info-success">{this.state.uploadCountText}</span>}
                <ButtonGroup className="pull-right">
                      {!this.props.overlayImageList && !this.props.pv_id && <Button id="show_overlay_button"disabled={this.state.attachments.length > 0 && !this.state.preLoaded} onClick={()=>{this.setState({selectedIndex:this.state.imageData.length});this.props.updateOverlayImageList(this.state.imageData); }} compact content="Show Photos Overlay"></Button>
                        }
                    {/* <Popup on="click" trigger={<Button compact negative content="Delete All" disabled={this.state.uploading}
                        className="icon-button" />}>
                        <Header as="h3">Are you sure?</Header>
                    <Button compact positive onClick={(e) => {
                        this.deleteAll()
                    }}>Confirm Delete</Button></Popup> */}

                    <Button primary compact content="Save" disabled={this.state.uploading} loading={this.state.uploading}
                        className="icon-button" onClick={(e) => {
                            this.handleSubmit()
                        }} />
                      
                        </ButtonGroup> 
                           {this.state.attachments.length > 0 && !this.state.preLoaded && <Label className="pull-right" compact basic color="orange" icon ><Icon name="warning sign" color="orange" size="large" />Unsaved</Label>}</Header>
                {this.state.maxNumberOfFilesExceeded &&
                    <p><span className="error-message">Max number of allowed files is 1</span></p>}
                <DropzoneComponent key={this.props.inspection_id} config={componentConfig}
                    eventHandlers={eventHandlers}
                    djsConfig={djsConfig} /></React.Fragment>}

                    {/* SHOW OVERLAY --------------------------------------- */}
                    {this.props.overlayImageList&& <Segment className={"image-overlay-segment"}
                    secondary>
            <div style={{marginRight:"2vw",textAlign:"right"}}>   

            <ButtonGroup style={{marginRight:"2%"}}>
              <Popup wide="very" on="click" trigger={<Button compact icon="settings" basic />}
              content={
                <div className='bottom-margin'>
                  <Header>Image Sort Order</Header>
                                    <span></span>
                  <Button  compact fluid content="Date Created Ascending" basic onClick={()=>{this.sortAdditionalImages("dateasc")}}/>    
                  <Button  compact fluid content="Date Created Descending" basic onClick={()=>{this.sortAdditionalImages("datedesc")}}/>         
                  <Button  fluid compact  content="File Name Ascending" basic onClick={()=>{this.sortAdditionalImages("filenameasc")}}/>
                  <Button  fluid compact  content="File Name Descending" basic onClick={()=>{this.sortAdditionalImages("filenamedesc")}}/>
                    <hr/>
                    <Header>Performance Mode    <Button onClick={()=>{this.setState({lagMode:!this.state.lagMode})}}>{this.state.lagMode? "ON" : "OFF"}</Button></Header>
                    <Message>NOTE: Turning Performance Mode ON will not render pictures 25 images ahead or behind the current selected picture to optimize performance. Choose this if you find your phone is lagging when working with a lot of pictures. Some scrolling behaviour may be erratic in this mode depending on the device.</Message>
                 
                </div>
              }></Popup>
             {this.state.showCamera && <Popup wide="very" on="click" trigger={<Button  compact icon="refresh" basic />}
              content={
                <div className='bottom-margin'>
                  <Header>Camera Select</Header>
                  <span>NOTE: Some devices need to use the cycle button to select cameras, while others need to use the dedicated buttons.</span>
                  <Button  compact fluid content="Cycle Cameras" icon="refresh" basic onClick={()=>{this.toggleCamera()}}/>          
                    <Button  fluid compact  icon="photo" content="Front" basic onClick={()=>{this.startCameraStream({ facingMode: "user",})}}/>
                      <Button  fluid  icon="photo" compact content="Back" basic onClick={()=>{this.startCameraStream({ facingMode: "environment",})}}/>
                      {/* <Button  fluid  icon="photo" compact content="Back (LQ Test)" basic onClick={()=>{this.startCameraStream({ facingMode: "environment",    width: {ideal: 640}, 
    height: {ideal: 480},})}}/> */}
                </div>
              }></Popup>}
                {this.stream && this.state.torchSupported && <Button  compact basic color="grey" icon onClick={()=>{this.toggleTorch()}}><Icon name="lightning"/>{this.state.torchEnabled ? "ON" : "OFF"}</Button>}
                {this.state.uploadErrors.length > 0 && <Button icon onClick={()=>{this.retryFailedUploads()}}loading={this.state.uploadingPhoto} compact basic color="red"><Icon name='exclamation circle' color="red" size="large" />{this.state.uploadErrors.length} Errors</Button>}
                {this.props.overlayImageList.filter((image) => image.loading === true).length > 0 &&  <ButtonGroup>
    <Button  compact basic color="blue" loading></Button>
<Button  compact basic color="blue" > {this.props.overlayImageList.filter((image) => image.loading === true).length} </Button></ButtonGroup>}
            {this.state.showCamera ?   <Button  compact icon basic onClick={()=>{this.closeCamera()}}>
            <Icon name='photo' /> Hide </Button> :
            <Button basic  compact icon onClick={()=>{this.setState({showCamera:true },()=>{this.startCameraStream({ facingMode: "environment",})})}}> 
            <Icon name='photo' /> Show </Button>}
{!this.state.isMobile &&            <React.Fragment>
                <Button basic compact icon onClick={()=>{this.jumpToItem(-10)}}>
                    <Icon name='fast backward' />
                </Button>
                <Button basic compact icon onClick={()=>{this.jumpToItem(-1)}}>
                    <Icon name='caret left' />
                </Button>
                <Button basic compact>{this.state.selectedIndex} of {this.props.overlayImageList.length}</Button>
                <Button  basic compact onClick={()=>{this.jumpToItem(1)}}  icon>
                    <Icon name='caret right' />
                </Button>
                <Button  basic compact onClick={()=>{this.jumpToItem(10)}}  icon>
                    <Icon name='fast forward' />
                </Button>
            </React.Fragment>}
                </ButtonGroup>         
                <ButtonGroup style={{marginRight:"2%"}}>
                <Button basic onClick={()=>{if (this.state.overlayHeight > 0) {this.setState({overlayHeight:this.state.overlayHeight-10})}}} icon>
                    <Icon name='caret down' />
                </Button>
                <Button  basic onClick={()=>{if (this.state.overlayHeight < 80) {this.setState({overlayHeight:this.state.overlayHeight+10})}}}  icon>
                    <Icon name='caret up' />
                </Button>
                </ButtonGroup>
                    <Button icon  compact negative onClick={()=> {this.closeCamera(); this.props.setSelectedOverlayImage(undefined); this.props.updateOverlayImageList();this.reloadAdditionalImages()}}>    <Icon name='close' /></Button>
                    </div>
                    <div className={"image-overlay-inner"}>
                      {this.state.showCamera && <React.Fragment> <div  style={{ display: "inline-block", position: "relative" }}>
    <video ref={this.videoRef} autoPlay muted playsInline id="active_camera_overlay" onClick={this.handleCapture} style={{position: "relative",display: "inline-block", width: "auto", height: `${this.state.overlayHeight - 10}vh`}}className={`image-overlay image-overlay-canvas ui image ${this.state.isFlashing ? 'flash-white' : ''}`}/>
    {/* Capture Button */}
    {/* <Button
      icon circular onClick={this.handleCapture} style={{position: "absolute",bottom: "10px", left: "50%", width:`${this.state.overlayHeight}px`, height:`${this.state.overlayHeight}px`,transform: "translateX(-50%)",zIndex: 1005}}
    > <Icon name="camera" />
    </Button> */}
  </div></React.Fragment>}
  {[...this.props.overlayImageList].reverse().map((img, index) =>{ if ( (!this.state.lagMode) || (this.state.lagMode  && (index > selectedPicIndex-25) && (index < selectedPicIndex+25)) )
    return <Image className={`image-overlay ${this.props.overlayImage && this.props.overlayImage.id === img.id? "image-overlay-selected":"image-overlay-unselected"} ${img.loading? "image-overlay-blur":""}`}id={`${img.id}`} 
                        onClick={(e)=>{this.props.setSelectedOverlayImage(img,false, this.state.lagMode);
                        }} 
                        key={img.id} src={img.file} style={{ display: "inline-block",height:`${this.state.overlayHeight -10}vh`}}></Image>})}
                        </div>
                    </Segment>}
                    </div>);
                    }
                }

export default ReportContainer(AdditionalPhotos);


// WEBPACK FOOTER //
// ./src/views/report/additional_photos.js